import { makeStyles } from "@mui/styles";
import { SURVEY_COLORS } from "../../../shared/theme-constants";
import { getSharedStyles } from "../../../shared/shared-styles";

export const useStyles = makeStyles((theme) => ({
  ...getSharedStyles(theme),
  contentWrapper: {
    paddingTop: "32px",
    paddingBottom: "32px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  iconWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  iconBox: {
    backgroundColor: "#dcfce7",
    padding: "16px",
    borderRadius: "50%",
  },
  errorIconBox: {
    backgroundColor: "#fee2e2",
    padding: "16px",
    borderRadius: "50%",
  },
  successIcon: {
    width: "64px",
    height: "64px",
    color: "#16a34a",
  },
  errorIcon: {
    width: "64px",
    height: "64px",
    color: "#dc2626",
  },
  title: {
    fontSize: "30px",
    fontWeight: 700,
    marginBottom: "12px",
    color: SURVEY_COLORS.TEXT_PRIMARY,
  },
  description: {
    fontSize: "18px",
    color: SURVEY_COLORS.TEXT_SECONDARY,
    marginBottom: "24px",
  },
  referenceBox: {
    display: "inline-block",
    backgroundColor: "rgba(0, 51, 141, 0.1)",
    padding: "12px 24px",
    borderRadius: "8px",
    marginBottom: "24px",
  },
  referenceText: {
    fontSize: "24px",
    fontFamily: "monospace",
    fontWeight: 700,
    color: "#00338D",
    margin: 0,
  },
  confirmationText: {
    fontSize: "14px",
    color: SURVEY_COLORS.TEXT_SECONDARY,
    maxWidth: "448px",
    margin: "0 auto",
  },
  buttonContainer: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "100%",
    },
  },
  primaryButton: {
    backgroundColor: "#00338D !important",
    color: "white !important",
    fontWeight: 600,
    minWidth: "140px",
  },
  loadingContainer: {
    padding: theme.spacing(8, 2),
    textAlign: "center",
  },
  icon: {
    width: 64,
    height: 64,
    color: "#00338D",
    animation: "$spin 2s linear infinite",
  },
  searchingLabel: {
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(1),
    fontSize: "0.95rem",
  },
  searchingRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    width: "100%",
  },
  progressTrack: {
    height: 8,
    background: "#e0e0e0",
    borderRadius: 999,
    overflow: "hidden",
    width: 240,
    maxWidth: "60%",
  },
  progressFill: {
    height: "100%",
    background: SURVEY_COLORS.BUTTON_PRIMARY,
    borderRadius: 999,
    transition: "width 0.5s ease-out",
  },
  progressFillError: {
    height: "100%",
    background: theme.palette.error.main,
    borderRadius: 999,
    transition: "width 0.5s ease-out",
  },
  progressStyle: {
    position: "absolute",
    width: 1,
    height: 1,
    opacity: 0,
    pointerEvents: "none",
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));
